import { z } from 'zod';

import { MoneySchema } from '@/shared/lib/money';

export const CitySchema = z.object({
  id: z.string(),
  name: z.string(),
  region: z.string().nullable(),
  hasPickup: z.boolean(),
});
export type City = z.infer<typeof CitySchema>;
export const CityListSchema = z.array(CitySchema);

export const DeliveryOptionSchema = z.object({
  id: z.enum(['pickup', 'courier', 'post']),
  title: z.string(),
  /** Tariff and term line under the title. */
  description: z.string(),
  price: MoneySchema,
  isFree: z.boolean(),
  available: z.boolean(),
});
export type DeliveryOption = z.infer<typeof DeliveryOptionSchema>;
export const DeliveryOptionListSchema = z.array(DeliveryOptionSchema);

export const PickupPointSchema = z.object({
  id: z.string(),
  kind: z.enum(['pvz', 'postamat']),
  carrier: z.string(),
  address: z.string(),
  hours: z.string(),
  distance: z.string(),
  /** Storage term as shown to the customer. */
  storage: z.string(),
  /** Suggested point for the city (nearest or last used). */
  preselected: z.boolean(),
  /** Position on the schematic mock map, percent of width/height. */
  x: z.number().min(0).max(100),
  y: z.number().min(0).max(100),
});
export type PickupPoint = z.infer<typeof PickupPointSchema>;
export const PickupPointListSchema = z.array(PickupPointSchema);

export const deliveryKeys = {
  cities: (query: string) => ['delivery', 'cities', query] as const,
  options: (city: string) => ['delivery', 'options', city] as const,
  points: (city: string) => ['delivery', 'points', city] as const,
};

export function pickupPointLabel(point: PickupPoint): string {
  return `${point.carrier} · ${point.address}`;
}

export function pickupPointMeta(point: PickupPoint): string {
  return `${point.hours} · ${point.distance} · срок хранения ${point.storage}`;
}
